export default "__VITE_ASSET__zMVYieqa__"